import {  useEffect } from 'react';
import '../../styles/Navigation.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSport } from '../../context/SportContext.tsx';
import { logUserActivity } from '../../services/player/LoginService.tsx';
import { useUser } from '../../context/UserContext.tsx';

/**
 * Represents a set of navigation buttons.
 * Allows users to navigate between different sections or options.
 */
function Navigation() {
  const { showSports, setShowOptions, showOptions, sports, setActiveGamesTeaser, boxesRef, setSelectedGames, setIsParlay, setSelectedGamesTeaser, 
    setCheckedTeaserLeagues, setCheckedLeagues } = useSport();
  const { user, userIpData } = useUser();

  const navigate = useNavigate();
  const location = useLocation();

  const openFirstLeagueSport = () => {
    const visibleSports = sports
      .map((sport) => ({
        ...sport,
        leagues: sport.leagues?.filter((league) => league.isActive) ?? [],
      }))
      .filter((sport) => sport.leagues.length > 0);

    const sportIndex = visibleSports.findIndex((sport) => sport.isOpen);
    if (sportIndex === -1) return;

    setShowOptions(prev => {
      const updated = new Array(Math.max(prev.length, visibleSports.length)).fill(false);
      updated[sportIndex] = true;
      return updated;
    });
  };

  useEffect(() => {
    if (location.pathname === "/home/teaser") {
      setCheckedLeagues({})
      setSelectedGames(false)
    }
    if (location.pathname !== "/home/teaser") {
      setActiveGamesTeaser([]);
      setSelectedGamesTeaser(false)
      setCheckedTeaserLeagues({})

    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === "/home/parlay") {
      setIsParlay(true);

      if (window.innerWidth < 1000) {
        openFirstLeagueSport();
      }

    } else if (location.pathname === "/home") {

      setIsParlay(false);

      if (window.innerWidth < 1000) {
        openFirstLeagueSport();
      }

    } else {
      setIsParlay(false);
    }
  }, [location.pathname, sports]);


  useEffect(() => {
    if (user && location.pathname === "/home") {
      const today = new Date().getDay();
      if (today === 0 || today === 6) {
        openFirstLeagueSport();
      }
    }
  }, [user, location.pathname, sports]);


  const handleNavigation = (path) => {
    if (location.pathname === path) {
      navigate(0);
    } else {
      navigate(path);
    }
  };

  useEffect(() => {
    showOptions.forEach((isOpen, index) => {
      const box = boxesRef.current[index];
      if (!box) return;

      box.style.maxHeight = isOpen ? box.scrollHeight + 'px' : '0px';
    });
  }, [showOptions]);

  useEffect(() => {
    let actionName = "";

    switch (location.pathname) {
      case "/home":
        actionName = "Straight";
        break;
      case "/home/parlay":
        actionName = "Parley";
        break;
      case "/home/teaser":
        actionName = "Teaser";
        break;
    }

    if (actionName) {
      logUserActivity(user.userName, `View ${actionName}`, userIpData);
    }
  }, [location.pathname]);


  return (
    <>
      {showSports && (
        <div className='button-container mt-lg-5 mb-lg-2'>
          <button className={`button ${location.pathname === "/home" ? "active" : ""}`} onClick={() => handleNavigation("/home")} >
            <span className='option'>STRAIGHT</span>
          </button>
          <button className={`button ${location.pathname === "/home/parlay" ? "active" : ""}`} onClick={() => handleNavigation("/home/parlay")} >
            <span className='option'>PARLAY</span>
          </button>
          <button className={`button ${location.pathname === "/home/teaser" ? "active" : ""}`} onClick={() => handleNavigation("/home/teaser")} >
            <span className='option'>TEASER</span>
          </button>
        </div>
      )}
    </>
  );
};

export default Navigation;